import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { RouteShareService } from '../../services/route-share.service';
import { WebscrapeService } from '../../services/webscrape.service';

export const webscrapeResolver: ResolveFn<boolean> = async (route, _state) => {
  const webscrapeSerivce: WebscrapeService = inject(WebscrapeService);
  const rss: RouteShareService = inject(RouteShareService);

  const id = route.parent?.params['id'] as string;

  rss.webscrapes = (await webscrapeSerivce.getWebscrapesForBot(id)).webscrapes;
  const webscrapeid = route.firstChild?.params['webscrapeid'] as string;
  if (webscrapeid) {
    rss.webscrape = rss.webscrapes.find(scrape => scrape._id === webscrapeid);
    if (rss.webscrape) {
      for (const keyURL of rss.webscrape.distinctPages) {
        rss.webscrapeMap.set(keyURL, rss.webscrape.pages.filter(page => keyURL == page.url));
      }
    }
  } else {
    rss.webscrape = undefined;
    rss.webscrapeMap.clear();
  }
  return true;
};
